<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.6453 19.3333C5.87065 19.3333 2 15.4531 2 10.6667C2 5.88019 5.87065 2 10.6453 2C15.42 2 19.2907 5.88019 19.2907 10.6667C19.2907 12.6912 18.5982 14.5536 17.4377 16.0288L21.6983 20.2557C22.0976 20.6518 22.101 21.2973 21.7058 21.6976C21.3107 22.0978 20.6667 22.1012 20.2675 21.7051L15.9999 17.4714C14.5274 18.6374 12.6675 19.3333 10.6453 19.3333ZM10.6453 17.2941C14.2966 17.2941 17.2565 14.3269 17.2565 10.6667C17.2565 7.00642 14.2966 4.03921 10.6453 4.03921C6.99411 4.03921 4.0342 7.00642 4.0342 10.6667C4.0342 14.3269 6.99411 17.2941 10.6453 17.2941Z"
      fill="currentColor"
    />
    <path
      d="M15.647 10.6563C15.647 13.4177 13.4084 15.6563 10.647 15.6563C7.88559 15.6563 5.64702 13.4177 5.64702 10.6563C5.64702 7.89486 7.88559 5.65628 10.647 5.65628C13.4084 5.65628 15.647 7.89486 15.647 10.6563Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'MagnifyingGlassIconFilled',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
